import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Editorcontrolitem } from '../models/editorcontrolitem.model';
import { BaseComponent } from '../base.component';
import { MatDialog } from '@angular/material/dialog';
import { SettingComponent } from '../setting/setting.component';
import { DynamicFieldsManagerService } from '../service/dynamic-fields-manager.service';
import { DataService } from '../service/data.service';

@Component({
  selector: 'app-builder',
  templateUrl: './builder.component.html',
  styleUrls: ['./builder.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class BuilderComponent extends BaseComponent implements OnInit {

  sourceBuilderTools = [
    { name: 'Section', children: [] as any[], inputType: 'section', icon: 'far fa-square', class: 'wide' },
    { name: 'String', inputType: 'string', icon: 'fas fa-language', class: 'half' },
    { name: 'Number', inputType: 'number', icon: 'fas fa-hashtag', class: 'half' }
  ];

  targetBuilderTools: any[] = [];
  settingsOpened = false;

  constructor(data: DataService, public settingsDialog: MatDialog, private bindServide: DynamicFieldsManagerService) {
    super(data);
  }

  ngOnInit() {

  }

  droppableItemClass = (item: any) => `${item.Type}`;

  builderDrag(e: any) {
/*     const item = e.value;
    item.data =
      item.inputType === 'number'
        ? (Math.random() * 100) | 0
        : Math.random()
          .toString(36)
          .substring(20); */
  }

  log(e: any) {

    if(e.type == 'drop'){
      this.data.chechItemToBeAddedFromComplex(e.value);
    }
  }

  canMove(e: any): boolean {
    return e.indexOf('Disabled') === -1;
  }


  changeSelectedItem(event: any, item: Editorcontrolitem) {
    if(this.data.selectedItem == null || this.data.selectedItem.Id!=item.Id || this.data.selectedItem.ControlClientId != item.ControlClientId){
      this.data.selectedItem = item;
      this.data.prepareTmpItem();
      this.data.getControlSettingsUiData(item.Type);
      this.data.getControlConverters(item.Type);
    }

    event.stopPropagation();
  }

  onSettingsClick(){
    this.openSettings();
  }

  closeSettings(){
   
  }

  onDeleteClick(item:Editorcontrolitem){
      this.removeItem(this.data.editor.Controls, item.Id, item.ControlClientId); 
  }

  removeItem(array: Editorcontrolitem[], idToRemove:number, clientid:string){
    array.forEach(i=>{
      if(i.Id == idToRemove && i.ControlClientId == clientid){
        var index = array.indexOf(i);
        if(index>-1){
        
          this.data.chechItemToBeRemovedFromComplex(array[index]);
          array.splice(index,1);

          return;
        }
      }else{
        if(i.Children!=null && i.Children.length>0){
          this.removeItem(i.Children, idToRemove, clientid);
        }
      }
    });    
  }

  openSettings(){
    this.data.prepareTmpItem();
    this.settingsDialog.open(SettingComponent, {
      width: '800px',
    });
  }

  openConvertersList(){
    if(this.data.convertersListVisible){
      this.data.convertersListVisible = false;
    }else{
      this.data.convertersListVisible = true;
    }    
  }

  convertSelectedControlTo(targetConverter:string){
    this.data.executeConverter(targetConverter);
  }

  getFirstChild(array){
    let arr = [];

    console.log(array);
    
    if(typeof array.Children != "undefined" && array.Children && array.Children.length > 0){
      arr[0] = array[0];
    } 

    return arr;
  }

  getRightSideChildren(array){
    let arr = [];

    console.log(array);
    
    if(typeof array.Children != "undefined" && array.Children){
      arr = array.Children.slice(1);
    } 

    return arr;
  }

}


